import { getBaseURL, getAIBaseURL, getAIWSURL } from '../config/app.config';

// Export the BASE_URL using the config file
export const BASE_URL = getBaseURL();
export const AI_BASE_URL = getAIBaseURL();
export const AI_WS_URL = getAIWSURL();
